import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandHeader from "@/components/BrandHeader";
import Footer from "@/components/Footer";

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-display text-base uppercase tracking-tight text-white mt-8 mb-2">{title}</h2>
    <div className="space-y-2">{children}</div>
  </div>
);

export default function Datenschutz() {
  return (
    <div className="min-h-screen relative z-10" data-testid="datenschutz-page">
      <BrandHeader minimal />
      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-14">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-white/50 hover:text-brand-orange transition-colors">
          <ArrowLeft className="h-4 w-4" /> Zur Startseite
        </Link>
        <h1 className="mt-8 font-display uppercase text-3xl tracking-tight text-white">Datenschutzerklärung</h1>

        <div className="mt-4 text-sm text-white/70 leading-relaxed">
          <Section title="Verantwortliche Stelle">
            <p>Florian Ebert · feNANCE Controlling Systems</p>
            <p>Eduard-Dressler-Str. 1, 63762 Großostheim</p>
            <p>Telefon: +49 (0) 60 26 / 99 600 65 · E-Mail: <a href="mailto:fe@fenance.de" className="text-brand-orange hover:underline">fe@fenance.de</a></p>
          </Section>

          <Section title="Welche Daten wir im Tragfähigkeits-Check verarbeiten">
            <p>
              Die Selbstbewertung ist grundsätzlich anonym. Es werden Ihre Antworten (Noten je
              Handlungsfeld), das Datum und die daraus berechnete Auswertung gespeichert.
            </p>
            <p>
              Wenn Sie Ihren Lagebericht als PDF anfordern, verarbeiten wir zusätzlich die von Ihnen
              angegebenen Daten (Name, E-Mail-Adresse, ggf. Firma und Umsatzgröße) sowie Ihre
              Einwilligung, um Ihnen den Bericht zuzusenden und Sie ggf. zu kontaktieren.
            </p>
          </Section>

          <Section title="Zweck & Rechtsgrundlage">
            <p>
              Die Verarbeitung erfolgt zur Bereitstellung der Auswertung und – bei Anforderung des
              Berichts – zur Zusendung und Kontaktaufnahme. Rechtsgrundlage ist Ihre Einwilligung
              (Art. 6 Abs. 1 lit. a DSGVO) bzw. die Durchführung vorvertraglicher Maßnahmen
              (Art. 6 Abs. 1 lit. b DSGVO) sowie unser berechtigtes Interesse an der effektiven
              Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
          </Section>

          <Section title="Widerruf & Speicherdauer">
            <p>
              Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft an
              fe@fenance.de widerrufen. Ihre Daten werden gelöscht, sobald der Zweck entfällt und
              keine gesetzlichen Aufbewahrungsfristen entgegenstehen.
            </p>
          </Section>

          <Section title="Empfänger / Auftragsverarbeiter">
            <p>
              Für den E-Mail-Versand des Berichts setzen wir einen E-Mail-Dienstleister als
              Auftragsverarbeiter ein. Eine Weitergabe an Dritte erfolgt darüber hinaus nur, soweit
              gesetzlich erforderlich oder von Ihnen eingewilligt.
            </p>
          </Section>

          <Section title="Ihre Rechte">
            <p>
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
              Verarbeitung, Datenübertragbarkeit sowie ein Widerspruchs- und Beschwerderecht bei der
              zuständigen Aufsichtsbehörde. Details und die vollständige Datenschutzerklärung finden
              Sie unter{" "}
              <a href="https://fenance.de/datenschutz" target="_blank" rel="noopener noreferrer" className="text-brand-orange hover:underline">fenance.de/datenschutz</a>.
            </p>
          </Section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
